<template>
  <div>
    <HeadlineContainer headline="Payment Conditions" :breadcrumbs="[{text: 'Payment Conditions'}]">
      <router-link to="/payment-conditions/create" class="btn btn-white">
        <i class="fa fa-plus"></i> Create
      </router-link>
    </HeadlineContainer>

    <div class="container">
      <PaymentConditionList/>
    </div>
  </div>
</template>

<script>
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import PaymentConditionList from '../../../components/Administration/PaymentConditions/Panels/List'

export default {
  components: {HeadlineContainer, PaymentConditionList}
}
</script>
